"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateRBACAppConfig = function (user) {
  var config = {};
  var features = user.features,
    gates = user.gates;
  // check access to automation application
  var orgHasAutomation = !!gates.has_automation;
  var userHasAutomation = utils_1.hasFeature(features, {
    featureName: "automation_playbooks",
    accessLevel: "READ"
  });
  config = ramda_1.set(ramda_1.lensProp('hasAutomation'), orgHasAutomation && userHasAutomation, config);
  return config;
};
exports["default"] = generateRBACAppConfig;